import { StaffAddress } from '../../management360/staff/models/faculty-staff.model';

export class Staff {
    $id: number;
    StaffId: number;
    EmployeeNumber: string;
    FirstName: string;
    MiddleName: string;
    LastName: string;
    UserId: number;
    Selected: boolean;
    // v9
    StaffName: string;
    SchoolName: string;
    StaffRole: string;
    StaffStatus: string;
    UserName: string;
    PermissionGroup: string;
    StateId: string;
    ForceNewPassword: boolean;
    IsBlankPassword: boolean;
    LastLoginDate: Date;
    GenderTypeCode: string;
    PeopleId: number;
    // V9 Staff Header
    FTE = 1.000;
    HireDate: string;
    InActiveDate: string;
    SSN = '';
    CellPhone = '';
    Pager = '';
    EmailAddress = '';
    GenderTypeId: number;
    RaceTypeId: number;
    FamilyId: number;
    FacultyStaffId = 0;
    Pin = '';
    Unlisted = false;
    FacultyStaffEmail = '';
    SchoolExt = '';
    TeacherFlg = false;
    SpecialtyCodeId: number;
    SpecialeducationTeacherFlg = false;;
    SubstituteFlg = false;
    AdvisorFlg = false;
    CounselorFlg = false;
    NurseFlg = false;
    DisciplinarianFlg = false;
    AdministratorFlg = false;
    SuperintendentFlg = false;
    PrincipalFlg = false;
    OtherFlg = false;
    MinPerWeek = 0;
    SpecialServicesSupervisor = false;
    CaseManager = false;
    ServiceProvider = false;
    MedicaidSupervisorFlg = false;
    FormerSisId = '';
    HumanResourceId = '';
    PhotoTakenDate: Date;
    IdPrintedDate: Date;
    DateofBirth: Date = null;
    BilingualLanguageId: number;
    EmployeeStatusId: number;
    TerminationReasonId: number;
    StaffClassificationId: number;
    EthnicityTypeId: number;
    FormerLastName = '';
    TribalAffiliation = '';
    CertificationNumber = '';
    NurseType: string;
    HighlyQualified = false;;
    HighestCompletedLevel = '';
    GiftedEndorsed = false;
    HomeTel1 = '';
    HomeTel2 = '';
    MaritalStatus: number;
    PrefixId: number;
    SuffixId: number;
    SpousePrefixId: number;
    SpouseWorkPhone = '';
    SpouseExtension = '';
    SpouseFirstName = '';
    SpouseMiddleName = '';
    SpouseLastName = '';
    SpouseCellPhone = '';
    SpouseSuffixId: number;
    SpouseEmailAddress = '';
    SpousePeopleId: number;
    Employer = '';
    IsDisabled = false;
    StaffPrimaryAddress: StaffAddress;
    PrimarySiteYearId: number;
    HasSchoolSpecificPermissions: boolean;
    SiteId: number;
    SiteName: string;
    IsTeacher: boolean;

    // Non DTO Field V9 //
    TextFTE: string;
    readOnly = false;
    staffInactiveDate: Date;
    SelectedSchools: string[] = [];

    // V10
    UseInScheduling: boolean;
}

export class StaffSearchCriteria {
    EmployeeNumber: string;
    FirstName: string;
    LastName: string;
    SchoolId: number;
    UserName: string;
    Status: string;
    ShowAllSchools: boolean;
    ShowAllPermissionsGroups: boolean;
}

export class StaffEmergencyContact {
    Id: number;
    FamilyId: number;
    PeopleId: number;
    FirstName: string;
    LastName: string;
    MiddleName: string;
    FullName: string;
    CellPhone: string;
    RelationshipTypeId: number;
    RelationshipType: string;
    Comment: string;
    Note: string;
    Sequence: number;

    // Home Address Fields
    HomeAddressId: number;
    HomeAddress: string;
    HomeCity: string;
    HomeState: string;
    HomeZipCode: string;
    HomePhone: string;

    // // Work Address Fields
    WorkAddressId: number;
    WorkAddress: string;
    WorkCity: string;
    WorkState: string;
    WorkZipCode: string;
    WorkPhone: string;
    WorkPhoneExt: string;
}

